export enum ETransferQueryKey {
  ADMIN_LIST_TRANSFER_TICKETS = 'admin-list-transfer-tickets',
  ADMIN_CLOSE_TRANSFER_TICKET = 'admin-close-transfer-ticket',
}
